<script lang="ts" setup>
import ConnxInformational from '@/components/Atoms/ConnxInformational.vue';
</script>

<template>
  <div>
    <h5 class="tw-mb-4">About Workforce Assistance Reports</h5>
    <p class="tw-mb-1">
      The Workforce Assistance Reports page provides Unrestricted HR Administrators with a comprehensive reporting tool
      to track and analyse employee-related data.
    </p>

    <p>
      This functionality is designed to offer insights into employee movements and workforce trends. These Workforce
      Assistance Reports may be able to assist you with your reporting requirements, including to some government
      agencies
      such as the Workplace Gender Equality Agency (WGEA) Australia.
    </p>

    <connx-informational>
      <p class="tw-mb-0"><strong>Disclaimer:</strong></p>
      <p>
        These Workforce Assistance Reports are provided “as is”. ConnX Pty Ltd makes no representations or warranties of
        any kind, express or implied, as to the accuracy or completeness of the data generated or whether it will meet
        your
        requirements for use in any capacity whatsoever. By generating and using a Workforce Assistance Report you
        acknowledge that you use and rely on the data contained in the reports at your own risk and that ConnX Pty Ltd
        its
        directors, officers, employees, servants, authorised distributors and agents have no responsibility or liability
        to
        you in any way whatsoever.
      </p>
    </connx-informational>

    <h5 class="tw-mt-10 tw-mb-4">Understanding each Workforce Assistance Report</h5>

    <ol class="tw-list-decimal tw-ml-4">
      <li class="tw-mb-2">
        Employee Changes
        <ul class="tw-list-disc tw-ml-4">
          <li>Reports the data of employee change records which are approved and processed on the effective date under
            <strong>Manage Employee Changes.</strong>
          </li>
          <li>Only includes data that has been approved and processed on the effective date through <strong>Manage
              Employee Changes</strong>,
            starting from the date you upgraded to V7.0.</li>
        </ul>
      </li>
      <li class="tw-mb-2">
        New Employee Records
        <ul class="tw-list-disc tw-ml-4">
          <li>Reports the data of new employee records which are approved and processed on the effective date under
            <strong>Manage New
              Employees.</strong>
          </li>
          <li>Only includes data that has been approved and processed on the effective date through <strong>Manage New
              Employees</strong>, starting from the date you upgraded to V7.0.</li>
        </ul>
      </li>
      <li class="tw-mb-2">
        Employee Separations
        <ul class="tw-list-disc tw-ml-4">
          <li>Reports the data of employee separations which are approved and processed on the effective date under
            <strong>Manage Employee
              Separations.</strong>
          </li>
          <li>Only includes data that has been approved and processed on the effective date through <strong>Manage
              Employee
              Separations</strong>,
            starting from the date you upgraded to V7.0.</li>
        </ul>
      </li>
      <li class="tw-mb-2">
        Leave Applications
        <ul class="tw-list-disc tw-ml-4">
          <li>Reports data on all leave applications regardless of workflow status including employee details.</li>
        </ul>
      </li>
      <li class="tw-mb-2">
        Workplace Profiles
        <ul class="tw-list-disc tw-ml-4">
          <li>Reports data on employee's profile at the time the report is generated.</li>
        </ul>
      </li>
    </ol>
    <h5 class="tw-mt-4 tw-mb-4">Important Notes</h5>
    <p>Source of Data:</p>
    <ul class="tw-list-disc tw-ml-4">
      <li>
        Data is derived exclusively from activities recorded within your ConnX system.
      </li>
      <li>External imports, including payroll-specific data, are not included in these reports.</li>
    </ul>
    <p class="tw-my-4">Roles and Positions Data:</p>
    <ul class="tw-list-disc tw-ml-4">
      <li>Data relating to Roles and Positions will only be displayed if your organisation has the corresponding module
        enabled.</li>
    </ul>
  </div>
</template>